import {ISearchPage,ICmSearchPageFields} from "../../../types/FmsTypes";
export enum OptType {
    ADD_ROOT = 1,//跟
    ADD_SAME_LEVEL = 2,//同级
    ADD_CHILD_LEVEL = 3,//孩子
    DETAIL = 4//编辑
}
//搜索参数
export interface IOrganParams {
    enable?:string,
    name?:string,
    branch?:string
}
//列表参数
export interface IOrganDetail {
    "note"?: string,
    "ver"?: number,
    "code"?: string,
    "address"?: string,
    "sourceAuthKey"?: null|string,
    "pcode"?: null|string,
    "branch"?: string,
    "phone"?: string,
    "children"?: IOrganDetail[]|null,
    "enable"?: number,
    "contact"?: string,
    "name"?: string,
    "key"?: string
}
//新增参数
export interface IOrganInsert {
    "sourceApp"?: string,
    "branch"?: string,
    "code"?: string,
    "name"?: string,
    "contact"?: string,
    "phone"?: string,
    "address"?: string,
    "note"?: string,
    "enable"?:boolean|number,
    [key:string]:any
}
//修改参数
export interface IOrganUpdate{
    "sourceApp"?: string,
    "branch"?: string,
    "code"?: string,
    "name"?: string,
    [key:string]:any

}
//禁用参数
export interface IOrganDisable{
    "sourceApp": string,
    "branch": string,
    "code": string
}
//删除参数
export interface IOrganRemove{
    "sourceApp"?: string,
    "branch"?: string,
    "code"?: string,
    [key:string]:any
}

export interface IOrganSearch extends IOrganParams,ICmSearchPageFields{

}